ii/* ===== Cart mit Mindestmengen-Schutz (vollständig) ===== */

/* Fallback: debounce, falls nicht global vorhanden */
if (typeof debounce !== 'function') {
  var debounce = function (fn, wait) {
    let t; 
    return function(...args){ clearTimeout(t); t = setTimeout(()=>fn.apply(this,args), wait); };
  };
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		/* ---- Mindestmengen-Helfer ---- */
		getMinQty(qtyInput){
			// Priorität: data-minqty (aus Liquid), dann min-Attribut, sonst 1
			const fromData = parseInt(qtyInput?.dataset?.minqty, 10);
			if (!isNaN(fromData) && fromData > 0) return fromData;
			const fromAttr = parseInt(qtyInput?.getAttribute('min') || '1', 10);
			return isNaN(fromAttr) ? 1 : Math.max(1, fromAttr);
		}

		normalizeQty(value, minQty){
			const n = parseInt(value, 10);
			if (isNaN(n)) return minQty;
			return Math.max(minQty, n);
		}
		/* ------------------------------ */

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					});
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					/* Mindestmenge ermitteln & absichern */
					const minQty = this.getMinQty(qty);
					qty.setAttribute('min', String(minQty));

					/* FRONTEND-HARDENING:
					   - Tippen verhindern (nur +/- Buttons erlauben)
					   - Scroll & Paste sperren
					   - Sicherheits-Clamp auf allen Events
					*/
					qty.setAttribute('readonly', 'readonly');
					qty.addEventListener('wheel', e => e.preventDefault(), { passive:false });
					qty.addEventListener('paste', e => e.preventDefault());
					qty.addEventListener('keydown', e => e.preventDefault());

					const clampToMin = () => {
						qty.value = String(this.normalizeQty(qty.value, this.getMinQty(qty)));
					};

					// Dein bestehendes Verhalten: debounced Update bei "input".
					// Da wir readonly setzen, kommt "input" nur noch über +/- zustande (gut!).
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						clampToMin();
						qty.blur();
						this.updateCartQty(item, parseInt(qty.value, 10));
					}, 500));

					qty.addEventListener('change', clampToMin);
					qty.addEventListener('blur', clampToMin);

					// UX: Klick selektiert (falls per DevTools readonly entfernt wird)
					qty.addEventListener('click', (e)=>{
						e.target.select();
					});
				}

			});

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			/* SERVER-SICHERUNG:
			   Bevor wir an Shopify senden, Mindestmenge final durchsetzen.
			*/
			const qtyInput = item.querySelector('.qty');
			const safeMin = this.getMinQty(qtyInput);
			newQty = this.normalizeQty(newQty, safeMin);
			if (qtyInput) qtyInput.value = String(newQty);

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// Lager-/Fehler-Hinweis
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					/* SANITY-PASS nach Re-Render:
					   Falls ein Item < Mindestmenge gerendert wurde, sofort korrigieren.
					*/
					cartItems.querySelectorAll('[data-js-cart-item]').forEach(it => {
						const q = it.querySelector('.qty');
						if (!q) return;
						const min = cartItems.getMinQty ? cartItems.getMinQty(q) : 1;
						const cur = parseInt(q.value, 10) || 0;
						if (cur < min) {
							q.value = String(min);
							cartItems.updateCartQty(it, min);
						}
					});

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 

	if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}
}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				const item = this.closest('[data-js-cart-item]');
				const qtyInput = this.querySelector('.qty');
				const cartFormEl = document.getElementById('AjaxCartForm');

				// Mindestmenge auch bei +/- erzwingen
				if (cartFormEl && typeof cartFormEl.getMinQty === 'function' && typeof cartFormEl.normalizeQty === 'function') {
					const minQty = cartFormEl.getMinQty(qtyInput);
					qtyInput.value = String(cartFormEl.normalizeQty(qtyInput.value, minQty));
				}

				document.getElementById('AjaxCartForm').updateCartQty(item, parseInt(qtyInput.value, 10));
			}, 50);
		}
	}

	if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}
}

/* --- Für Apps: Cart-Refresh mit Mindestmengen-Check --- */
if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			/* SANITY-PASS auch hier */
			cartItems.querySelectorAll('[data-js-cart-item]').forEach(it => {
				const q = it.querySelector('.qty');
				if (!q) return;
				const min = cartItems.getMinQty ? cartItems.getMinQty(q) : 1;
				const cur = parseInt(q.value, 10) || 0;
				if (cur < min) {
					q.value = String(min);
					cartItems.updateCartQty(it, min);
				}
			});

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			});
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		});

	};

}
